



























import {
  Vue, Component, Prop, ModelSync, Ref,
} from 'vue-property-decorator';

@Component
export default class ItemsPerPageSelect extends Vue {
  isMenuActive = false

  @Ref() readonly select!: { isMenuActive: boolean }

  @ModelSync('value', 'change', { type: Number, default: () => 10 }) selectedItem!: number

  @Prop({ type: Array, default: () => [] }) readonly items!: never[]

  @Prop({ type: Number, required: false }) readonly selectedText!: string

  @Prop({ type: String, required: false }) readonly label!: string

  @Prop({ type: Boolean, default: false }) readonly medium!: boolean

  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean;

  @Prop({ type: Boolean, default: false }) readonly loading!: boolean;

  @Prop({ type: Object, default: () => ({}) }) readonly vselectProps!: Record<string, unknown>

  get localLabel(): string {
    return this.label ? this.label : '';
  }

  mounted(): void {
    this.$watch('select.isMenuActive', (v) => {
      this.isMenuActive = v;
    });
  }

  isSelectedTextShown(index: number): boolean {
    return index === 0 && !!this.selectedText;
  }
}
